import React from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable, type PressableProps } from '@atlaskit/primitives/pressable';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { type XCSS, xcss } from '@atlaskit/primitives/xcss/xcss';

import { messages } from './messages';

type ClearFilterOptionsButtonProps = {
	text?: MessageDescriptor;
	xcss?: XCSS;
} & PressableProps;

const ClearFilterButton = ({
	text = messages.clearFilterButtonLabel,
	xcss,
	...props
}: ClearFilterOptionsButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Pressable {...props} xcss={[clearFilterOptionsButtonStyles, xcss]}>
			<Text>{formatMessage(text)}</Text>
		</Pressable>
	);
};

export default ClearFilterButton;

const clearFilterOptionsButtonStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle',
	color: 'color.text.subtle',
	border: 'none',
	paddingLeft: 'space.250',
	font: 'inherit',
	cursor: 'pointer',
	outline: 'inherit',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '36px',
	width: '100%',

	':hover': {
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},

	':active': {
		backgroundColor: 'color.background.neutral.subtle.pressed',
	},

	':disabled': {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
		color: 'color.text.accent.gray',
		cursor: 'default',
	},
});
